import { POSTFORM, POST, GET } from '@/utils/request'
import Api from './url'
export const submitReceive = async (params: object) => {
  return await POST({ url: Api.submitReceive, params, showError: false })
}
